import { GoogleGenerativeAI } from "@google/generative-ai";

const context = `
You are an AI assistant embedded in Kevin Nguyen's personal portfolio website.
Your ONLY job is to answer questions about Kevin.
If asked anything unrelated, respond: "Sorry, I can only answer questions about Kevin.
If asked about the opportunities, please respond that I am open to opportunities for Internship and Graduate jobs.

About Kevin:
- Third year Software Engineering student based in Australia
- Programming skills: React, JavaScript, REST APIs, Java, Python, ASP.NET
- DSA knowledge: Arrays, linked lists, stacks, queues, trees, graphs, sorting algorithms, searching algorithms, Big O notation
- Soft skills: Communication, problem solving, team work, Agile/Scrum.
- Tools: Microsoft SQL, Ubuntu, Figma, Lucid, Supabase.
- Projects: Finding pets - Pawpals, financial web - myFinFriend, order simulation - OrderTime

Please add more words that convince other that I am trustworhty and worth to work for them. However, you should write 2-3 sentences and maximum 200 characters for visitor to read.
`;

const genAI = new GoogleGenerativeAI(process.env.REACT_APP_GEMINI_API);
const model = genAI.getGenerativeModel({
  model: "gemini-2.5-flash",
  systemInstruction: context,
});

export async function Receiver(message, history = []) {
  try {
    const chatHistory = history.slice(0, -1).map(m => ({
      role: m.role === "assistant" ? "model" : "user",
      parts: [{ text: m.content }],
    }));

    const chat = model.startChat({ history: chatHistory });
    const result = await chat.sendMessage(message);
    return result.response.text();
  } catch (error) {
    console.error(error);
    return "Please ask again in a few seconds. My brain is relax.";
  }
}